module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/component/shared/table/table.component.less
// module id = ./src/app/component/shared/table/table.component.less
// module chunks = tableDemo.module